import CustomBtn from "components/fragments/CustomBtn";
import CustomInput from "components/fragments/CustomInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { authHandler } from "../redux/handlers";
import LogoutConfirmModal from "../components/modals/LogoutConfirmModal";
import socketService from "../services/socketService";

const pinCount = 4;

export default function PinVerification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [pin, setPin] = useState("");
  const [isError, setIsError] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const branch = useSelector((state) => state.pos.branch);
  const branchList = useSelector((state) => state.pos.branchList || []);

  useEffect(() => {
    setIsError(undefined);
    setErrorMessage("");
  }, [pin]);

  const handleSubmitPin = async () => {
    if (!branch) {
      return;
    }
    if (pin.length !== 4) {
      setIsError("true");
      setErrorMessage("กรุณากรอกรหัสให้ครบ 4 หลัก");
      return;
    }

    try {
      setIsLoading(true);

      const branchData = {
        branchId: `${branch.branch_id}`,
        pin: pin,
      };

      const response = await dispatch(authHandler.authenticateBranch(businessSlug, branchData));

      if (response) {
        setIsError(undefined);
        setPin("");
        localStorage.setItem("branchId", branch.branch_id);
        navigate(`/${businessSlug}/pos-setting`);
      } else {
        setIsError("true");
        setErrorMessage(response?.message || "รหัสไม่ถูกต้อง กรุณาลองอีกครั้ง");
      }
    } catch (error) {
      console.error("Branch authentication failed:", error);
      setIsError("true");
      setErrorMessage("เกิดข้อผิดพลาด กรุณาลองอีกครั้ง");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelClick = () => {
    if (branchList.length === 1) {
      setShowLogoutModal(true);
    } else {
      navigate(`/${businessSlug}/branch-selection`);
    }
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutModal(false);
    localStorage.removeItem("email");
    localStorage.removeItem("branchId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("branchKitchenId");
    localStorage.removeItem("branchPOSId");
    socketService.disconnect();
    await dispatch(authHandler.logout(businessSlug));
    navigate(`/${businessSlug}/login`, { replace: true });
  };

  return (
    <div className="login-bg w-full min-h-screen flex justify-center items-center sarabun text-[var(--color-black)] p-[1vw]">
      <div className="bg-white p-[min(2.92vw,30px)] flex flex-col items-center rounded-[min(2.44vw,25px)] w-[min(39.16vw,401px)]">
        <div className="bg-white w-[min(38.67vw,396px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-18 text-[var(--color-black-2)] text-center leading-[1.8] font-[700]">
          <div className="leading-[2.2]">กรุณาใส่รหัสยืนยัน</div>
          <div className={"flex justify-center mt-[min(1.46vw,15px)]"}>
            <OTPInput
              value={pin}
              onChange={setPin}
              numInputs={pinCount}
              inputStyle={null}
              renderSeparator={<div className="w-[min(1.95vw,20px)]"></div>}
              renderInput={(props, index) => {
                const { style, ...rest } = props;
                return (
                  <CustomInput
                    className="w-[min(5.96vw,61px)] aspect-square"
                    inputprops={{
                      ...rest,
                      className: "rounded-[min(0.78vw,8px)] border-[min(0.29vw,3px)] border-[#b6bbc6] font-[400] text-24 text-center no-spinner",
                      type: "number",
                      error: isError,
                    }}
                  />
                );
              }}
            />
          </div>

          {isError && <div className="text-red-500 text-14 mt-[min(0.98vw,10px)]">{errorMessage}</div>}

          <div className="flex justify-center gap-[min(2.01vw,20.63px)] mt-[min(2.44vw,25px)]">
            <CustomBtn
              onClick={handleCancelClick}
              className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-[#6D788D] font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-second-2-active`}
              btntxt={"ยกเลิก"}
              disabled={isLoading}
            />
            <CustomBtn
              onClick={handleSubmitPin}
              className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-main-active`}
              btntxt={isLoading ? "กำลังตรวจสอบ..." : "ยืนยัน"}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>

      <LogoutConfirmModal isOpen={showLogoutModal} onClose={handleCancelLogout} onConfirm={handleConfirmLogout} />
    </div>
  );
}
